import { isActiveDatesEducationPreviewEnabled } from "utils/activeDatesEducationDismiss";
import { shouldEducateEmptyPresentForSelectedDate } from "utils/activeDatesMissingContentDetection";

export const ACTIVE_DATES_EDUCATION_TRIGGERS = Object.freeze({
  DATE_NAVIGATION: "date_navigation",
  DAY_ROLLOVER: "day_rollover",
});

export const ACTIVE_DATE_SYNCED_TO_TODAY_EVENT = "lesson-launchpad:active-date-synced-to-today";

const LAST_PRESENT_VISIT_KEY_PREFIX = "llp-active-dates-education-last-present-day:";

const buildLastPresentVisitKey = (uid) => (uid ? `${LAST_PRESENT_VISIT_KEY_PREFIX}${uid}` : null);

export function isEarlierDateKey(earlierDateKey = "", laterDateKey = "") {
  if (!earlierDateKey || !laterDateKey) {
    return false;
  }

  return earlierDateKey < laterDateKey;
}

export function getLastPresentVisitDateKey(uid) {
  if (!uid || typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage.getItem(buildLastPresentVisitKey(uid));
  } catch {
    return null;
  }
}

export function recordPresentVisitDateKey(uid, dateKey) {
  if (!uid || !dateKey || typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(buildLastPresentVisitKey(uid), dateKey);
  } catch {
    // no-op
  }
}

export function clearLastPresentVisitDateKey(uid) {
  if (!uid || typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(buildLastPresentVisitKey(uid));
  } catch {
    // no-op
  }
}

export function shouldTriggerActiveDatesEducationForScenario({
  trigger = "",
  previewBypassTriggers = isActiveDatesEducationPreviewEnabled(),
  useActiveDates = false,
  isShareView = false,
  contentBoxesReady = false,
  selectedDateKey = "",
  realTodayKey = "",
  classId = "",
  classContentBoxesOrder = [],
  presentDayVisibleCount = 0,
  lastPresentVisitDateKey = null,
} = {}) {
  if (!shouldEducateEmptyPresentForSelectedDate({
    useActiveDates,
    isShareView,
    contentBoxesReady,
    selectedDateKey,
    classId,
    classContentBoxesOrder,
    presentDayVisibleCount,
  })) {
    return false;
  }

  if (previewBypassTriggers) {
    return true;
  }

  if (trigger === ACTIVE_DATES_EDUCATION_TRIGGERS.DATE_NAVIGATION) {
    return true;
  }

  if (trigger === ACTIVE_DATES_EDUCATION_TRIGGERS.DAY_ROLLOVER) {
    if (!realTodayKey || selectedDateKey !== realTodayKey) {
      return false;
    }

    if (!lastPresentVisitDateKey) {
      return false;
    }

    return isEarlierDateKey(lastPresentVisitDateKey, realTodayKey);
  }

  return false;
}
